import { ProfilePageComponent } from './modules/profile/components/profile-page/profile-page.component';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './modules/auth/components/auth/auth.guard';
import { HelpSupportModalComponent } from './modules/help-and-support/modals/help-support-modal/help-support-modal.component';
import { MandatoryPasswordChangeGuard } from './modules/auth/components/auth/mandatory-password-change.guard';

const appRoutes: Routes = [
  { path: '', redirectTo: '/my-dashboard', pathMatch: 'full' },
  {
    path: 'help',
    component: HelpSupportModalComponent
  },
  // { path: 'management', loadChildren: () => import('./management/management.module').then(m => m.ManagementModule) },
  { path: 'management', loadChildren: () => import('./modules/management/management.module').then(m => m.ManagementModule) },
  { path: 'history', loadChildren: () => import('./modules/learning-center/components/history/history.module').then(m => m.HistoryModule), canActivate: [AuthGuard] },
  { path: 'reports', loadChildren: () => import('./modules/obsolete/components/reports/reports.module').then(m => m.ReportsModule), canActivate: [AuthGuard] },
  { path: 'myprograms', loadChildren: () => import('./modules/obsolete/components/my-programs/my-programs.module').then(m => m.MyProgramsModule), canActivate: [AuthGuard] },

  // { path: 'organization', loadChildren: () => import('./organization/organization.module').then(m => m.OrganizationModule), canActivate:[AuthGuard] },
  { path: 'organization', loadChildren: () => import('./modules/obsolete/components/my-programs/organization.module').then(m => m.OrganizationModule) },
  { path: 'program-builder-main', loadChildren: () => import('./modules/creation-center/components/program-builder-main/program-builder-main.module').then(m => m.ProgramBuilderMainModule) },

  { path: 'profile-page', loadChildren: () => import('./modules/profile/components/profile-page/profile-page.module').then(m => m.ProfilePageModule) },

  { path: 'group', loadChildren: () => import('./modules/obsolete/components/group/group.module').then(m => m.GroupModule), canActivate: [AuthGuard] },

  { path: 'change-filter', loadChildren: () => import('./modules/obsolete/components/change-filter-page/change-filter-page.module').then(m => m.ChangeFilterPageModule), canActivate: [AuthGuard] },

  { path: 'my-learning', loadChildren: () => import('./modules/obsolete/components/my-learning/my-learning.module').then(m => m.MyLearningModule), canActivate: [AuthGuard] },

  { path: 'analytics', loadChildren: () => import('./modules/analytics/components/analytics/analytics.module').then(m => m.AnalyticsModule), canActivate: [AuthGuard] },

  { path: 'my-library', loadChildren: () => import('./modules/learning-center/components/my-library/my-library.module').then(m => m.MyLibraryModule), canActivate: [AuthGuard] },

  { path: 'my-dashboard', loadChildren: () => import('./modules/learning-center/components/my-dashboard/my-dashboard.module').then(m => m.MyDashboardModule), canActivate: [AuthGuard] },

  // { path: 'management-conponents', loadChildren: () => import('./management/management-components/managementComponents.module').then(m => m.ManagementComponentsModule) },

  { path: 'tabs', loadChildren: () => import('./modules/management/components/tabs/tabs.module').then(m => m.TabsComponentsModule) },

  { path: 'login', loadChildren: () => import('./modules/auth/components/auth/auth.module').then(m => m.AuthModule) },

  { path: 'achieve-program-data/:programId/:userId', loadChildren: () => import('./modules/obsolete/components/achieve-program-data/achieve-program-data.module').then(m => m.AchieveProgramDataModule) },

  { path: 'rewards', loadChildren: () => import('./modules/rewards/components/rewards/rewards.module').then(m => m.RewardsModule), canActivate: [AuthGuard] },
  { path: 'programs', loadChildren: () => import('./modules/learning-center/components/program-page/program-page.module').then(m => m.ProgramPageModule), canActivate: [AuthGuard] },

  { path: 'impact-dashboard', loadChildren: () => import('./modules/obsolete/components/impact-dashboard/impact-dashboard.module').then(m => m.ImpactDashboardModule), canActivate: [AuthGuard] },

  { path: 'audit-builder', loadChildren: () => import('./modules/creation-center/components/audit-builder/audit-builder.module').then(m => m.AuditBuilderModule) },

  { path: 'audit-visitation', loadChildren: () => import('./modules/store-visitation/components/audit-visitation/audit-visitation.module').then(m => m.AuditVisitationModule), canActivate:[AuthGuard] },

  { path: 'audit-visitation-builder', loadChildren: () => import('./modules/store-visitation/components/audit-visitation-builder/audit-visitation-builder.module').then(m => m.AuditVisitationBuilderModule), canActivate:[AuthGuard] },

  { path: 'admin-analytics', loadChildren: () => import('./modules/analytics/components/analytics-main/analytics-main.module').then(m => m.AnalyticsMainModule), canActivate: [AuthGuard] },

  { path: 'forgot-password', loadChildren: () => import('./modules/auth/components/forgot-password/forgot-password.module').then(m => m.ForgotPasswordModule) },
  { path: 'reset-password', loadChildren: () => import('./modules/auth/components/reset-password/reset-password.module').then(m => m.ResetPasswordModule) },
  { path: 'change-password', loadChildren: () => import('./modules/auth/components/change-password/change-password.module').then(m => m.ChangePasswordModule), canActivate: [AuthGuard] },

  { path: 'podcasts', loadChildren: () => import('./modules/learning-center/components/podcasts/podcasts.module').then(m => m.PodcastsModule) },

  { path: '**', loadChildren: () => import('./modules/auth/components/auth/auth.module').then(m => m.AuthModule) },

];

const routes: Routes = [
  {
    path: '',
    canActivateChild: [MandatoryPasswordChangeGuard],
    children: appRoutes
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
